export default __webpack_public_path__ + "244ae3f.png";